import Vue from 'vue';
import { gsap, Quad, Quint } from 'gsap/all';

Vue.component('blog-filter', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            filter: 'blogs',
            showBlogFilters: false,
            inclusives: [],
            excludes: [],
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.blogFiltersHolder = this.$el.querySelector('.filter-list');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        close() {
            this.toggleBlogFilters();
        },

        /**
        * Toggles the filters
        *
        * @return {Void}
        */
        toggleBlogFilters(event) {
            console.log('toggle');
            this.showBlogFilters = !this.showBlogFilters;

            if (this.showBlogFilters) {
                // Show
                gsap.to(this.blogFiltersHolder, 0.8, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });
                return;
            }

            // Hide
            gsap.to(this.blogFiltersHolder, 0.8, {
                height: 0,
                ease: Quint.easeOut,
            });
        },

        /**
        * Toggles the filter
        *
        * @return {Void}
        */
        toggleBlogFilter(event) {
            if (event.currentTarget.classList.contains('toggle-filter-group--active')) {
                // Hide
                gsap.to(event.currentTarget.nextElementSibling, 0.5, {
                    height: 0,
                    ease: Quint.easeOut,
                });
            } else {
                // Show
                gsap.to(event.currentTarget.nextElementSibling, 0.5, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });
            }

            event.currentTarget.classList.toggle('toggle-filter-group--active');
        },

        /**
        * Toggles the filter
        *
        * @return {Void}
        */
        toggleListFilter(event) {
            const div1 = event.currentTarget.previousElementSibling;
            const btn = event.currentTarget;

            if (!div1.classList.contains('active')) {
                gsap.to(div1, 0.4, {
                    height: 0,
                    ease: Quad.easeIn,
                });

                div1.classList.add('active');
                btn.firstChild.classList.remove('hide');
                btn.lastElementChild.classList.add('hide');
            } else {
                gsap.to(div1, 0.4, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });

                div1.classList.remove('active');
                btn.firstChild.classList.add('hide');
                btn.lastElementChild.classList.remove('hide');
            }
        },

    },
});
